import type { ReactNode } from "react";

/** Reading-width single column per §10.5. */
export function PageShell({
  eyebrow,
  title,
  lead,
  children,
}: {
  eyebrow?: ReactNode;
  title: ReactNode;
  lead?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="mx-auto max-w-[44rem] px-5 py-16 md:py-20">
      {eyebrow && (
        <p className="mb-4 text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
          {eyebrow}
        </p>
      )}
      <h1 className="font-display text-4xl leading-[1.05] sm:text-5xl">{title}</h1>
      {lead && (
        <p className="mt-5 max-w-[38rem] text-base text-muted-foreground sm:text-lg">
          {lead}
        </p>
      )}
      {children && <div className="mt-10">{children}</div>}
    </div>
  );
}